export class TogleSlideVM {
    public slideId: number;
    public active: boolean;
}

export class UpdateSlideVM {
    public slideId: number;
    public slideName: string;
    public selectionId: number;
    public order: number;
    public active: boolean;
    public slidedData: string;
    public SlideType: number;
    public Url: string;
}

export class CreateSlideVM {
    public slideName:string;
    public selectionId: number;
    public order: number;
    public slideData:string;
    public SlideType: number;
    public URL:string;
}